import { z } from "zod";

import { Icon } from "@/client";
import i18n from "@/i18n";

const contentNavigationItemSchema = z.object({
  icon: z.nativeEnum(Icon),
  title: z
    .string()
    .min(1, { message: i18n.t("validation.navigationTitleRequired") })
    .trim(),
  visibility: z.string().optional(),
  content: z.string(),
});

type ContentNavigationItemFormData = z.infer<
  typeof contentNavigationItemSchema
>;

export { contentNavigationItemSchema };
export type { ContentNavigationItemFormData };
